// DO NOT CORRECT SPELLING - the following is purposefully misspelled - since the wcs api also misspells it.
export const OUT_OF_JURISTDICTION = 'OUT_OF_JURISTDICTION'
export const PACKAGING_OPTION_INVALID = 'PACKAGING_OPTION_INVALID'
export const _ERR_INVALID_SHIP_MODE = '_ERR_INVALID_SHIP_MODE'
